import { useId } from "react";

export const useDomId = () => useId().replace(/:/g, "");
